import endpoints from "../../../constants/endpoints";
import { adminApi } from "../client";

export const createBlogCategory = async (data) => {
  return await adminApi({
    endpoint: endpoints.BLOG_CATEGORY,
    method: "post",
    data: data,
  });
};

export const updateBlogCategory = async (data) => {
  const payload = {
    ...data,
  };
  return await adminApi({
    endpoint: `${endpoints.BLOG_CATEGORY}${data.id}/`,
    method: "patch",
    data: payload,
  });
};

export const getBlogCategory = async (data) => {
  return await adminApi({
    endpoint: endpoints.BLOG_CATEGORY,
    method: "get",
    params: data,
  });
};

export const deleteBlogCategory = async (data) => {
  return await adminApi({
    endpoint: `${endpoints.BLOG_CATEGORY}${data.id}/`,
    method: "delete",
  });
};

export const getBlogCategoryForDropdown = async (data) => {
  const res = await adminApi({
    endpoint: endpoints.BLOG_CATEGORY,
    method: "get",
    params: { page_size: 0 },
  });

  return res.data?.map((category) => ({
    value: category.id,
    label: category.name,
  }));
};
